// extracted by mini-css-extract-plugin
module.exports = {"inner":"Intro_inner__jNHoO","avatar":"Intro_avatar__3_2Oz"};